import { Box } from '@chakra-ui/react'
// import { AspectRatio } from '@chakra-ui/react'

import {
  ContentNotFound,
  Hero,
  Layout,
  SpectralFontFace,
  Sections,
  StickyHeader,
} from '@common'
import { ISSRPageData } from '@interfaces'
import { PageService } from '@services'
import useTranslation from 'next-translate/useTranslation'
import { useRouter } from 'next/router'

const ArtResearchAreaScreen = ({
  pageData,
  global: { navigation },
}: ISSRPageData) => {
  const { t } = useTranslation()
  const { asPath } = useRouter()

  if (pageData.error) {
    return (
      <Layout
        title={t('common:ssmPageTitle')}
        navigation={navigation}
        path={asPath}
      >
        <ContentNotFound infoType="serverSideError" />
      </Layout>
    )
  }

  return (
    <Layout
      title={pageData.data.pageTitle}
      navigation={navigation}
      path={asPath}
      activeFontFamily="spectral"
    >
      <style jsx global>{`
        .css-1ges8uc span > p {
          font-size: 20px;
        }
        .css-1ges8uc span > div > p {
          font-size: 20px;
        }

        .css-1ges8uc div > p {
          font-size: 20px;
        }
        .css-1ges8uc div > div > p {
          font-size: 20px;
        }
      `}</style>
      <SpectralFontFace />

      {/* <AspectRatio maxW="100%" ratio={2.14} >
            <iframe
          title="DigitalSSM"
          src="https://drupal.sakipsabancimuzesi.org/sites/muze.sabanciuniv.edu/files/2022-01/SSM%20Banner%20Dijital.mp4?controls=0"
          allowFullScreen />

      </AspectRatio> */}
      <Hero
        subTitle={pageData.data.hero.subTitle}
        title={pageData.data.hero.title}
        description={pageData.data.hero.description}
        bgImageUrl={pageData.data.hero.bgImageUrl}
      />
      {pageData.data.stickyNavItems &&
        pageData.data.stickyNavItems.length > 0 && (
          <Box as="main" pt={4}>
            <StickyHeader
              navs={pageData.data.stickyNavItems}
              activeFontFamily="spectral"
            />

            <Sections
              sections={pageData.data.sections}
              activeFontFamily="spectral"
            />
          </Box>
        )}
    </Layout>
  )
}

export default ArtResearchAreaScreen

export async function getStaticProps({ locale }) {
  const pageData = await PageService.getArchiveAndResearchAreaPageData(locale)

  return {
    props: { pageData },
  }
}
